import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import { imageURl } from "../../libs/env";
import { FeedbackContent, GradingContent } from "../ai_feedback/feedbackmodeldata";

const AiFeedbackModel = ({ isOpen, toggle, creatQuizDataAndSubmit, GenerateFeedback, data }) => {
  let modelContentdata = {}
  if(data && data?.ai_grading_task)
  {
    modelContentdata = GradingContent
  }
  else{
    modelContentdata = FeedbackContent
  }
  return (
    <Modal
      isOpen={isOpen}
      size="md"
      toggle={toggle}
      className="modal-dialog-centered"
      backdrop="static"
    >
      <ModalBody className="p-4">
        <div class="row align-items-center">
          <div class="col-10">
            <h3 class="text-dark text-start fs-5">
              <svg
                width="25"
                height="25"
                viewBox="0 0 17 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_8457_8215)">
                  <path
                    d="M3.18783 15.5832V12.0415M3.18783 4.95817V1.4165M1.41699 3.18734H4.95866M1.41699 13.8123H4.95866M9.20866 2.12484L7.98028 5.31862C7.78052 5.83799 7.68065 6.09767 7.52533 6.31611C7.38767 6.5097 7.21852 6.67885 7.02493 6.8165C6.80649 6.97182 6.54681 7.0717 6.02744 7.27146L2.83366 8.49984L6.02744 9.72821C6.54681 9.92797 6.80649 10.0279 7.02493 10.1832C7.21852 10.3208 7.38767 10.49 7.52533 10.6836C7.68065 10.902 7.78052 11.1617 7.98028 11.6811L9.20866 14.8748L10.437 11.6811C10.6368 11.1617 10.7367 10.902 10.892 10.6836C11.0297 10.49 11.1988 10.3208 11.3924 10.1832C11.6108 10.0279 11.8705 9.92797 12.3899 9.72821L15.5837 8.49984L12.3899 7.27146C11.8705 7.0717 11.6108 6.97182 11.3924 6.8165C11.1988 6.67885 11.0296 6.5097 10.892 6.31611C10.7367 6.09767 10.6368 5.83799 10.437 5.31861L9.20866 2.12484Z"
                    stroke="#2E58D4"
                    stroke-width="1.41667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_8457_8215">
                    <rect width="17" height="17" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <strong className="ps-1">
                {modelContentdata?.title}
              </strong>
            </h3>
          </div>
          <div class="col-2 text-end">
            <button onClick={() => {if(sessionStorage.getItem("showCancel"))
                  {
                    toggle();
                    sessionStorage.removeItem("showCancel");
                  }
                  else {
                    toggle();
                  }
                  }} className="btn p-0 me-2 ">
              <img src={`${imageURl}/close.png`} width="17px" alt="Cross img" />
            </button>
          </div>
        </div>
        <div className="col-12">
          <p class="text-dark my-3 text-start">
            {modelContentdata?.content}
          </p>
          <div className="fst-italic mb-1">Example:</div>
          <div className="col-12">
            <div
              className={"d-flex rounded-5 p-1 px-2"}
              style={{ backgroundColor: "#f4f4f4" }}
            >
              <span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 17 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_8457_8219)">
                    <path
                      d="M3.18783 15.5832V12.0415M3.18783 4.95817V1.4165M1.41699 3.18734H4.95866M1.41699 13.8123H4.95866M9.20866 2.12484L7.98028 5.31862C7.78052 5.83799 7.68065 6.09767 7.52533 6.31611C7.38767 6.5097 7.21852 6.67885 7.02493 6.8165C6.80649 6.97182 6.54681 7.0717 6.02744 7.27146L2.83366 8.49984L6.02744 9.72821C6.54681 9.92797 6.80649 10.0279 7.02493 10.1832C7.21852 10.3208 7.38767 10.49 7.52533 10.6836C7.68065 10.902 7.78052 11.1617 7.98028 11.6811L9.20866 14.8748L10.437 11.6811C10.6368 11.1617 10.7367 10.902 10.892 10.6836C11.0297 10.49 11.1988 10.3208 11.3924 10.1832C11.6108 10.0279 11.8705 9.92797 12.3899 9.72821L15.5837 8.49984L12.3899 7.27146C11.8705 7.0717 11.6108 6.97182 11.3924 6.8165C11.1988 6.67885 11.0296 6.5097 10.892 6.31611C10.7367 6.09767 10.6368 5.83799 10.437 5.31861L9.20866 2.12484Z"
                      stroke="#2E58D4"
                      stroke-width="1.41667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_8457_8219">
                      <rect width="17" height="17" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span className="px-2 fs-14">
                 {modelContentdata?.example}
                <b className={modelContentdata?.score_color}>{modelContentdata?.score}</b>
              </span>
            </div>
            <div className="text-end mt-3">
              <button
                type="submit"
                onClick={() => {
                  if(sessionStorage.getItem("showCancel"))
                  {
                    toggle();
                    sessionStorage.removeItem("showCancel");
                  }
                  else {
                    creatQuizDataAndSubmit({"hide_confirm":true})
                    toggle();
                  }
                }}
                className="btn fw-bold py-1 rounded-5 me-2 px-4"
                style={{
                  borderColor: "#2E58D4",
                  color: "#2E58D4",
                  backgroundColor: "#F0F5FC",
                }}
              >
                <span>Continue without</span>
              </button>
              <button
                type="button"
                onClick={() => {
                  if(data && data?.ai_grading_task)
                  {
                    GenerateFeedback({gen_marking_scheme:true});
                    toggle();
                  }
                  else {
                    GenerateFeedback();
                    toggle();
                  }
                }}
                className={"btn fw-bold py-1 rounded-5"}
                style={{
                  borderColor: "#2E58D4",
                  color: "#ffff",
                  backgroundColor: "#2E58D4",
                }}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 17 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_8730_8954)">
                    <path
                      d="M3.18783 15.5834V12.0417M3.18783 4.95841V1.41675M1.41699 3.18758H4.95866M1.41699 13.8126H4.95866M9.20866 2.12508L7.98028 5.31886C7.78052 5.83823 7.68065 6.09792 7.52533 6.31635C7.38767 6.50995 7.21852 6.67909 7.02493 6.81675C6.80649 6.97207 6.54681 7.07195 6.02744 7.27171L2.83366 8.50008L6.02744 9.72846C6.54681 9.92822 6.80649 10.0281 7.02493 10.1834C7.21852 10.3211 7.38767 10.4902 7.52533 10.6838C7.68065 10.9022 7.78052 11.1619 7.98028 11.6813L9.20866 14.8751L10.437 11.6813C10.6368 11.1619 10.7367 10.9022 10.892 10.6838C11.0297 10.4902 11.1988 10.3211 11.3924 10.1834C11.6108 10.0281 11.8705 9.92822 12.3899 9.72846L15.5837 8.50008L12.3899 7.27171C11.8705 7.07195 11.6108 6.97207 11.3924 6.81675C11.1988 6.67909 11.0296 6.50995 10.892 6.31635C10.7367 6.09792 10.6368 5.83823 10.437 5.31886L9.20866 2.12508Z"
                      stroke="white"
                      stroke-width="1.41667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_8730_8954">
                      <rect width="17" height="17" fill="#2E58D4" />
                    </clipPath>
                  </defs>
                </svg>
                <span className="ps-1">{modelContentdata?.btn_name}</span>
              </button>
            </div>
            <div className="text-end fs-14 pt-1" style={{ color: "#4A5567" }}>
            {modelContentdata?.credit_info}
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

AiFeedbackModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

AiFeedbackModel.defaultProps = { isOpen: false };

export default AiFeedbackModel;
